export class DynamicComponent {
  static meta: {
    // default: custom
    type?: string
    name: string
    locations?: string[]
  }
}
